import { css } from 'emotion';

export const name = css({
  ':hover': {
    color: '#00BFFF',
    cursor: 'pointer'
  },
  color: 'black'
});
